import React from "react";
import data from "../data/biodata.json";
import PortTobBar from "./top";
import Floater from "./floater";
import ThemeCustomizer from "./theme_customizer";
import { useTheme } from "../../theme/themeContext";

const PageShell = ({ children, compact = false }) => {
  const pagelist = data?.pages || [];
  const { preferences } = useTheme();
  const templateId = preferences.templateId || "glass";

  return (
    <div
      className={`main-landing-page template-shell template-shell--${templateId} mx-auto px-4 pb-24 text-skin-text md:px-6`}
    >
      <ThemeCustomizer />
      <PortTobBar list={pagelist} templateId={templateId} />
      <Floater />
      <div
        className={`template-content ${compact ? "space-y-6" : "space-y-8"}`}
        id="main-content"
      >
        {children}
      </div>
    </div>
  );
};

export default PageShell;
